import { Switcher, CodeSwitcher } from "../../../../src/components/switcher";
import React from "react";
export default {
  Switcher,
  CodeSwitcher,
  React
};
